<template>
    <div class="widthBox ">
        <!-- <h1 class="title txt_center mlr_240 mb_40 mt_80">{{ $t("PUMPKIN SEED OKRA POWDER is produced by EBERS PTY LTD") }} </h1>
        <div class="info2 f-20 mb_80">{{ $t("Collaborations_desc") }} </div> -->
				<h1 class="title txt_center mlr_240 mb_40 mt_80">{{ setting_list.title }} </h1>
				<div class="info2 f-20 mb_80 ">{{ setting_list.sub_title }} </div>
        <div v-for="(item,index) in partner_list" :key="item.id">
            <el-row v-if="index%2 == 0" :gutter="10" class="acea-row row-middle mb_80">
                <el-col :span="11" :xs="24">
                    <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
                </el-col>
                <el-col class="hidden-xs-only" :span="12" :xs="24" :offset="1">
                    <div class="mb_40 title txt_left">{{ item.name }}</div>
                    <div class="info2 f-20">{{item.desc}}</div>
                </el-col>
                <el-col class="hidden-sm-and-up" :span="12" :xs="24">
                    <div class="mb_40 title txt_left f-40">{{ item.name }}</div>
                    <div class="info2 f-20">{{item.desc}}</div>
                </el-col>
            </el-row>

            <el-row v-if="index%2 != 0"  :gutter="10" class="acea-row row-middle mb_80">
                <el-col :span="12" :xs="24"   class="hidden-xs-only">
                    <div class="mb_40 title txt_left">{{ item.name }}</div>
                    <div class="info2 f-20">{{item.desc}}</div>
                </el-col>
                <el-col :span="11" :xs="24" :offset="1"  class="hidden-xs-only">
                    <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
                </el-col>
                
                <el-col :span="11" :xs="24" class="hidden-sm-and-up">
                    <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
                </el-col>
                <el-col :span="12" :xs="24"  class="hidden-sm-and-up">
                    <div class="mb_40 title txt_left f-40">{{ item.name }}</div>
                    <div class="info2 f-20">{{item.desc}}</div>
                </el-col>
            </el-row>
        </div>
        

    </div>
</template>

<script>
export default {
    data(){
        return{
            partner_list:[],
						setting_list:{}
        }
    },
    created(){
        this.get_info()
    },
    methods:{
        async get_info(){
            let res = await this.$api.get("api/company.Partner/list", this.query);
            this.partner_list = res.data.partner_list
            this.setting_list = res.data.setting_list
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.info2{
    color: #4D4D4D;
}
    .mlr_240{
        width: 60%;
        margin: 0 auto;
        text-align: center;
    }
    .mb_40{
        margin-bottom: 40px;
    }
    .mb_80{
        margin-bottom: 80px;
    }
    .mt_80{
        margin-top: 80px;
    }
    .title{
        font-size: 28px;
    }
    .f-20{
        font-size: 14px;
    }
@media screen and(max-width:768px) {
    .mlr_240{
        width: 100%;
        text-align: center;
    }
    .mt_80{
        margin-top: 40px;
    }
    .mb_40{
        margin-bottom: 16px;
    }
    .f-20{
        font-size: 14px;
    }
    .mb_80{
        margin-bottom: 32px;
    }
    .f-40{
        font-size: 40px !important;
        margin-top: 16px;
    }
}
</style>